// import { useState } from "react";
// import { useNavigate } from 'react-router-dom';
// import './Navigation.css';
// import { Icon } from "../Icons/Icon";
// import { useUser } from "../DataService/UserContext";

// const Navigation = () => {
//   const [isMenuOpen, setIsMenuOpen] = useState(false);
//   const navigate = useNavigate();
//   const {user,signOut} = useUser();
//   console.log(user)
//   return (
    
//    <nav className="navbar">
    
//   <div className="nav-container">
//     <div className="navbar-inner">
//       <div
//         className="logo-container"
//         onClick={() => navigate('/')}
//         role="button"
//         tabIndex={0}
//       >
//         {/* <Logo /> */}
//         {/* <Icon.TestLogoNav width={30} height={30}/> */}
      
//         <h1 className="logo-text" style={{fontStyle:'italic'}}>Sandras hälsa</h1>
//       </div>

//       <div className="desktop-menu">
//         <div className="desktop-menu-links">
//           {/* <a href="#kurser">Kurser</a> */}
//           <a href="samtal" onClick={() => navigate('/samtal')}>Samtal</a>
//            <a href="courses" onClick={() => navigate('/courses')}>Kurser</a>
//           <a href="about" onClick={() => navigate('/about')}>Om oss</a>
//           <a href="contact" onClick={() => navigate('/contact')}>Kontakta</a>
//           {user?.roles.includes('admin')  && <a href="admin-home" onClick={() => () => navigate('/admin-home')}>Admin</a>}
//           {user?.roles.includes('member') && <a href="member-home" onClick={() => () => navigate('/member-home')}>Hem</a>}
//           <button
//             onClick={() => navigate('/membership')}
//             className="desktop-menu-button"
//           >
//             Bli medlem
//           </button>
//           <button
//           onClick={() => {
//             if(user){
//               signOut();
//             }else{
//               navigate('/sign-in')
//             }
            
//             }
//           }
//           className="desktop-menu-button"
//         >
//          {user ? 'Logga ut':'Logga in'} 
//         </button>
//         </div>
//       </div>

//       <div className="mobile-menu-button">
//         <div
//           onClick={() => setIsMenuOpen(!isMenuOpen)}
//           aria-label="Toggle menu"
          
//         >
//           {isMenuOpen ? 'X' :   <Icon.MenuIcon/>}
//         </div>
//       </div>
//     </div>
//   </div>

//   {isMenuOpen && (
//     <div className="mobile-menu">
//       <div className="mobile-menu-links">
//         <a href="samtal" onClick={() => navigate('/samtal')}>Samtal</a>
//         <a href="kurser" onClick={() => navigate('/courses')}>Kurser</a>
//           <a href="about" onClick={() => navigate('/about')}>Om oss</a>
//           <a href="contact" onClick={() => navigate('/contact')}>Kontakta</a>
//         <button
          
//           onClick={() => {
//             setIsMenuOpen(!isMenuOpen)
//             navigate('/membership')
//           }}
//           className="mobile-menu-button-join"
//         >
//           Bli medlem
//         </button>
//         {/* <button
//           onClick={() => {
//             if(user?.signedIn){
//                setIsMenuOpen(!isMenuOpen)
//               signOut();
//             }else{
//                setIsMenuOpen(!isMenuOpen)
//               navigate('/sign-in')
//             }
            
//             }
//           }
//           className="mobile-menu-button-join"
//         >
//           {user?.signedIn ? 'Logga ut':'Logga in'} 
//         </button> */}
//       </div>
//     </div>
//   )}
// </nav>
//   );
// };

// export default Navigation;
import React from "react";
import { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import "./Navigation.css";
import { Logo } from "./Logo";
import { Icon } from "../Icons/Icon";
import { useUser } from "../DataService/UserContext";
import { useCart } from "../DataService/CartContext";

const Navigation = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const { user, signOut } = useUser();
  const { totalItems } = useCart();

  React.useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };

    handleScroll();
    window.addEventListener("scroll", handleScroll);

    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const isActive = (path: string) => location.pathname === path;

  const navLinks = [
    { label: "Hem", path: "/" },
    { label: "Kurser", path: "/courses" },
    { label: "Boka Tid", path: "/booking" },
    { label: "Om mig", path: "/about" },
    { label: "Medlemskap", path: "/membership" },
    { label: "Kontakta", path: "/contact" },
  ];

  return (
    <nav className={`nav-root ${isScrolled ? "scrolled" : ""}`}>
      <div className="nav-container">
        <div className="nav-inner">

          <div className="nav-brand">
            <button
              type="button"
              className="nav-logo"
              onClick={() => navigate("/")}
              aria-label="Gå till startsidan"
            >
              <Logo />
            </button>

            
          </div>

          <div className="nav-desktop">
            {navLinks.map(link => (
              <button
                key={link.path}
                type="button"
                onClick={() => navigate(link.path)}
                className={`nav-link ${
                  isActive(link.path) ? "active" : ""
                }`}
              >
                {link.label}
              </button>
            ))}

            {user?.roles.includes("admin") && (
              <button
                type="button"
                onClick={() => navigate("/admin")}
                className="nav-admin-link"
              >
                Admin
              </button>
            )}
            {user?.roles.includes("member") && (
              <button
                type="button"
                onClick={() => navigate("/member-home")}
                className="nav-admin-link"
              >
                Mina sidor
              </button>
            )}

            <div className="nav-actions">
              <button
                type="button"
                onClick={() => navigate("/cart")}
                className="nav-cart-btn"
                aria-label="Varukorg"
              >
                <span className="nav-cart-icon-wrap">
                  <Icon.Cart fill="black" width={22} />
                  {totalItems > 0 && <span className="nav-cart-badge">{totalItems}</span>}
                </span>
              </button>

              <button
                type="button"
                onClick={() =>
                  user ? signOut() : navigate("/sign-in")
                }
                className="nav-user-btn"
                aria-label={user ? "Logga ut" : "Logga in"}
              >
                {user ? <Icon.SignOut width={22} height={22}/> : <Icon.SimpleGroup width={22} height={22} />}
              </button>
            </div>
          </div>

          <div className="nav-compact-actions">
            <button
              type="button"
              onClick={() => navigate("/cart")}
              className="nav-cart-btn nav-cart-btn--compact"
              aria-label="Varukorg"
            >
              <span className="nav-cart-icon-wrap nav-cart-icon-wrap--compact">
                <Icon.Cart fill="black" width={22} />
                {totalItems > 0 && <span className="nav-cart-badge">{totalItems}</span>}
              </span>
            </button>

            <button
              type="button"
              onClick={() =>
                user ? signOut() : navigate("/sign-in")
              }
              className="nav-user-btn"
              aria-label={user ? "Logga ut" : "Logga in"}
            >
              {user ? <Icon.SignOut width={22} height={22}/> : <Icon.SimpleGroup width={22} height={22} />}
            </button>
          </div>

          <button
            type="button"
            className="nav-mobile-toggle"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            aria-label="Öppna meny"
          >
            {isMenuOpen ? "✕" : <Icon.MenuIcon />}
          </button>
        </div>
      </div>

      {/* MOBILE MENU */}
      {isMenuOpen && (
        <div
          className="nav-mobile-backdrop"
          onClick={() => setIsMenuOpen(false)}
        >
          <div
            className="nav-mobile"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="nav-mobile-top">
              <div className="nav-mobile-brand">
                <button
                  type="button"
                  className="nav-logo"
                  onClick={() => {
                    setIsMenuOpen(false);
                    navigate("/");
                  }}
                  aria-label="Gå till startsidan"
                >
                  <Logo />
                </button>

                <button
                  type="button"
                  className="nav-home-pill"
                  onClick={() => {
                    setIsMenuOpen(false);
                    navigate("/");
                  }}
                >
                  Hem
                </button>
              </div>

              <button
                type="button"
                className="nav-mobile-close"
                onClick={() => setIsMenuOpen(false)}
              >
                Stäng
              </button>
            </div>

            <div className="nav-mobile-links">
              {navLinks.map(link => (
                <button
                  key={link.path}
                  type="button"
                  onClick={() => {
                    setIsMenuOpen(false);
                    navigate(link.path);
                  }}
                  className={`nav-mobile-link ${
                    isActive(link.path) ? "active" : ""
                  }`}
                >
                  {link.label}
                </button>
              ))}
            </div>

            <div className="nav-mobile-footer">
              {user?.roles.includes("admin") && (
                <button
                  type="button"
                  onClick={() => {
                    setIsMenuOpen(false);
                    navigate("/admin");
                  }}
                  className="nav-mobile-link nav-mobile-link--accent"
                >
                  Admin
                </button>
              )}

              {user?.roles.includes("member") && (
                <button
                  type="button"
                  onClick={() => {
                    setIsMenuOpen(false);
                    navigate("/member-home");
                  }}
                  className="nav-mobile-link nav-mobile-link--accent"
                >
                  Mina sidor
                </button>
              )}

              <button
                type="button"
                onClick={() => {
                  setIsMenuOpen(false);
                  user ? signOut() : navigate("/sign-in");
                }}
                className="nav-mobile-link nav-mobile-link--ghost"
              >
                {user ? "Logga ut" : "Logga in"}
              </button>
            </div>
          </div>
        </div>
      )}
    </nav>
  );
};

export default Navigation;
